import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CompanyUsersResponse,
  CreateNotificationPayload,
  CreateNotificationResponse,
  NotificationMetaDataResponse,
} from '../interfaces/apis/notifications';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  getMetadata(): Observable<NotificationMetaDataResponse> {
    return this.http.get<NotificationMetaDataResponse>(
      `${this.baseUrl}/notifications/meta-data`,
    );
  }

  getCompanyUsers(): Observable<CompanyUsersResponse> {
    return this.http.get<CompanyUsersResponse>(
      `${this.baseUrl}/users/company`,
      { params: { returnAll: 'true' } },
    );
  }

  createNotification(
    payload: CreateNotificationPayload,
  ): Observable<CreateNotificationResponse> {
    return this.http.post<CreateNotificationResponse>(
      `${this.baseUrl}/notifications`,
      payload,
    );
  }
}
